import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    admin: (() => {
      try { return JSON.parse(localStorage.getItem('admin') || 'null') } catch { return null }
    })()
  },
  getters: {
    isLoggedIn: s => !!s.token,
    isSuper: s => s.admin?.role === 'super',
    adminName: s => s.admin?.nickname || s.admin?.username || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
      localStorage.setItem('admin', JSON.stringify(admin))
    },
    SET_AUTH(state, { token, admin }) {
      state.token = token
      state.admin = admin
      localStorage.setItem('token', token)
      localStorage.setItem('admin', JSON.stringify(admin))
    },
    LOGOUT(state) {
      state.token = ''
      state.admin = null
      localStorage.removeItem('token')
      localStorage.removeItem('admin')
    }
  }
})